import request from "@/app/api/request";
import {
  MedicineSearchModel,
  MedicineModel,
  MedicinesSearchModel,
  MedicineShortModel, MedicineComparisonRequestModel, MedicineComparisonModel
} from "@/app/api/medicines/models";

export class MedicinesRequests {

  static async getMedicines(query: MedicinesSearchModel): Promise<MedicineShortModel[]> {
    try {
      return await request.get<MedicineShortModel[]>('/medicine/findmedicines', {query});
    } catch (error: any) {
      throw error;
    }
  }

  static async getMedicine(query: MedicineSearchModel): Promise<MedicineModel> {
    try {
      return await request.get<MedicineModel>("/medicine/choosemedicine", {query});
    } catch (error: any) {
      throw error;
    }
  }

  static async getComparison(query: MedicineComparisonRequestModel): Promise<MedicineComparisonModel[]> {
    try {
      const queryString = query.registrationNumbers
        .map(num => `registrationNumbers=${encodeURIComponent(num)}`)
        .join('&') + `&inputLanguage=${encodeURIComponent(query.inputLanguage)}`;
      return await request.post<MedicineComparisonModel[]>(`/assistant/compareft?${queryString}`, {});
    } catch (error: any) {
      throw error;
    }
  }
}

